import { useNavigate } from "react-router-dom";
import "./Welcome.css";

const FEATURES = [
    {
        icon: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <path d="M16 2v4M8 2v4M3 10h18" />
            </svg>
        ),
        title: "Turnos sin fricción",
        description: "Reservá, confirmá y reprogramá turnos en pocos clics, con notificaciones en tiempo real.",
    },
    {
        icon: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
            </svg>
        ),
        title: "Médicos y pacientes",
        description: "Un panel pensado para cada rol: cada quien ve solo lo que necesita.",
    },
    {
        icon: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
            </svg>
        ),
        title: "Disponibilidad clara",
        description: "Visualizá horarios, sedes y servicios disponibles sin llamadas ni planillas.",
    },
];

const STEPS = [
    { numero: "1", titulo: "Creá tu cuenta", texto: "Registrate como paciente en segundos." },
    { numero: "2", titulo: "Elegí turno", texto: "Buscá médico, especialidad y horario disponible." },
    { numero: "3", titulo: "Listo", texto: "Recibí notificaciones y gestioná tus turnos cuando quieras." },
];

const Welcome = () => {
    const navigate = useNavigate();

    return (
        <main className="welcome-page">
            <header className="welcome-nav">
                <div className="welcome-nav__brand">
                    <img src="/logo192.png" alt="Logo Sweet Medical" className="welcome-nav__logo" />
                    <span>Sweet Medical</span>
                </div>
                <div className="welcome-nav__actions">
                    <button type="button" className="welcome-nav__link" onClick={() => navigate("/login")}>
                        Iniciar sesión
                    </button>
                    <button type="button" className="primary-button" onClick={() => navigate("/registro")}>
                        Crear cuenta
                    </button>
                </div>
            </header>

            <section className="welcome-hero">
                <p className="welcome-hero__eyebrow">Gestión médica simple</p>
                <h1>
                    Tu centro médico, <span>organizado</span> de punta a punta.
                </h1>
                <p className="welcome-hero__description">
                    Administrá servicios, médicos, pacientes y turnos desde un único panel,
                    pensado para que reservar y confirmar un turno sea cuestión de segundos.
                </p>

                <div className="welcome-hero__actions">
                    <button type="button" className="primary-button" onClick={() => navigate("/registro")}>
                        Crear cuenta gratis
                    </button>
                    <button type="button" className="secondary-button" onClick={() => navigate("/login")}>
                        Ya tengo cuenta
                    </button>
                </div>
            </section>

            <section className="welcome-features">
                {FEATURES.map((feature) => (
                    <div className="welcome-feature-card" key={feature.title}>
                        <div className="welcome-feature-card__icon">{feature.icon}</div>
                        <h3>{feature.title}</h3>
                        <p>{feature.description}</p>
                    </div>
                ))}
            </section>

            <section className="welcome-steps">
                <p className="welcome-steps__eyebrow">Cómo funciona</p>
                <h2>Empezá en tres pasos</h2>
                <div className="welcome-steps__list">
                    {STEPS.map((step) => (
                        <div className="welcome-step" key={step.numero}>
                            <span className="welcome-step__numero">{step.numero}</span>
                            <h4>{step.titulo}</h4>
                            <p>{step.texto}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="welcome-cta">
                <h2>¿Listo para empezar?</h2>
                <p>Creá tu cuenta y reservá tu primer turno en minutos.</p>
                <button type="button" className="primary-button" onClick={() => navigate("/registro")}>
                    Crear cuenta
                </button>
            </section>

            <footer className="welcome-footer">
                <span>© {new Date().getFullYear()} Sweet Medical</span>
            </footer>
        </main>
    );
};

export default Welcome;